import axios from "axios";
import { getConfig } from "../../../common/env-config";

const { baseUrl } = getConfig();

// 🛠️ Create Axios instance for public blog APIs
const axiosInstance = axios.create({
  baseURL: `${baseUrl}/api`,
  headers: { "Content-Type": "application/json" },
  withCredentials: false,
});

// 🚀 Handle API responses and errors globally
axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (!error.response) {
      return Promise.reject(new Error("Network error, please try again."));
    }

    return Promise.reject(
      new Error(error.response.data?.message || "An error occurred.")
    );
  }
);

export { axiosInstance };
